(function () {
  // PAGN-02: Module-level shared observer (ENH-02)
  let sharedScrollObserver = null; // ENH-02

  const disconnectAll = () => {
    if (sharedScrollObserver) {
      sharedScrollObserver.disconnect();
      sharedScrollObserver = null;
    }
  };

  // ENH-02: Single shared IntersectionObserver factory — eliminates per-trigger observer accumulation
  const getSharedObserver = () => {
    if (!sharedScrollObserver) {
      sharedScrollObserver = new IntersectionObserver((entries) => {
        // Guard against callbacks queued before disconnectAll()
        if (!sharedScrollObserver) return;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const spinner = entry.target;
            const container = spinner.closest('[id^="shopify-section-"]') || document;
            sharedScrollObserver.unobserve(spinner);
            loadItems(spinner, container);
          }
        });
      });
    }
    return sharedScrollObserver;
  };

  const loadItems = (button, container) => {
    // PAGN-03: Null guard — [data-total-pages] only exists when paginate.pages > 1
    const totalPagesEl = container.querySelector('[data-total-pages]');
    if (!totalPagesEl) return;

    // PAGN-06: All pagination state reads scoped to container
    const totalPages = parseInt(totalPagesEl.value);
    let currentPage = parseInt(container.querySelector('[data-current-page]').value);
    let currentPageScroll = currentPage + 1;

    currentPage = currentPage + 1;
    const nextUrl = container.querySelector('[data-next-url]').value.replace(/page=[0-9]+/, 'page=' + currentPage);
    const nextUrlScroll = container.querySelector('[data-next-url]').value.replace(/page=[0-9]+/, 'page=' + currentPageScroll);
    container.querySelector('[data-current-page]').value = currentPage;

    button.setAttribute('disabled', '');
    button.classList.add('loading');

    fetch(nextUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newItems = doc.querySelector('.load-more-grid');
        if (newItems) {
          container.querySelector('.load-more-grid').insertAdjacentHTML('beforeend', newItems.innerHTML);
          // ENH-01: Update URL to reflect deepest page loaded — enables browser back-button to return to this page
          // Use window.location.href as base to preserve facet filter params already in URL (from facets.js)
          const url = new URL(window.location.href);
          url.searchParams.set('page', currentPage);
          history.replaceState({ page: currentPage }, '', url.toString());
        }
        colorSwatches();
      })
      // PAGN-04: Catch fetch errors so user can retry — reset button state
      .catch(() => {
        button.removeAttribute('disabled');
        button.classList.remove('loading');
      })
      .finally(() => {
        if (currentPage <= totalPages) {
          // PAGN-06: .finally() DOM queries also scoped to container
          const scrollData = container.querySelector('.infinite-scroll__data');
          if (scrollData && currentPage != totalPages) {
            scrollData.querySelector('input[data-next-url]').dataset.nextUrl = nextUrlScroll;
            scrollData.querySelector('input[data-next-url]').value = nextUrlScroll;
            scrollData.querySelector('input[data-current-page]').dataset.currentPage = currentPage;
            scrollData.querySelector('input[data-current-page]').value = currentPage;
            checkVisibility(scrollData.querySelector('.js-infinite-scroll') || scrollData);
          }
          button.removeAttribute('disabled');
          button.classList.remove('loading');
          if (currentPage == totalPages) {
            button.remove();
          }
        }
      });
  };

  const checkVisibility = (spinner) => {
    // ENH-02: Shared observer — container re-derived inside callback from entry.target
    getSharedObserver().observe(spinner);
  };

  function initLoadMore() {
    // PAGN-02: Disconnect all observers first — makes initLoadMore idempotent
    disconnectAll();

    // PAGN-06: Derive container per button via closest shopify section wrapper
    document.querySelectorAll('.js-load-more').forEach((button) => {
      const container = button.closest('[id^="shopify-section-"]') || document;
      button.onclick = () => {
        loadItems(button, container);
      };
    });

    // PAGN-02 + PAGN-06: checkVisibility scans globally; shared observer re-derives container from entry.target
    document.querySelectorAll('.js-infinite-scroll').forEach((spinner) => {
      checkVisibility(spinner);
    });
  }

  // PAGN-01: Expose window.loadMore global — satisfies bare-name loadMore() call in facets.js line 164
  window.loadMore = function () {
    disconnectAll();
    initLoadMore();
  };

  // PAGN-05: Theme Editor reinit — reinitialize when a section containing load-more is reloaded
  document.addEventListener('shopify:section:load', function (event) {
    const sectionEl = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (!sectionEl) return;
    if (sectionEl.querySelector('.js-load-more') || sectionEl.querySelector('.js-infinite-scroll')) {
      disconnectAll();
      initLoadMore();
    }
  });

  // Preserved: blog-content-updated listener for blog pagination reinit
  document.addEventListener('blog-content-updated', function () {
    initLoadMore();
  });

  // Initial call
  initLoadMore();
})();
